import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";

export async function renderFormStepWidget(context, widget, parent, override = null) {

    // <form class="widget form_step_widget">
    const form = context.document.createElement("form");
    const topDiv = context.document.getElementById("html_renderer");
    form.classList.add("widget", "form_step_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    if (override){
        styles["height"] = parent.style.height;
        styles["width"] = parent.style.width;
        styles["position"] = "relative";
        styles["background-color"] = parent.style.backgroundColor;
    }

    form.setAttribute("style", cssUtil.toStyleString(styles));
    form.setAttribute("data-widgetId", widget.uid);
    form.setAttribute("data-widgetType", widget.type);
    form.setAttribute("data-widgetParent", widget.parent);

    if (override){
        topDiv.appendChild(form);
    }
    else{
        parent.appendChild(form);
    }

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return form;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, form);
    }

    return form;
}